import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class GrsDashboardService {

  constructor(private http: HttpClient,
    private logger: NGXLogger) { }


  getGRSComplaintView(grsDashboard): any {
    //this.logger.debug("calling get api from GRSDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/grs/complaint-details/view', grsDashboard, { observe: 'response' });
  }
  getGRSTicketView(grsDashboard): any {
    //this.logger.debug("calling get api from GRSDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/grs/ticket-details/view', grsDashboard, { observe: 'response' });
  }
  getGRSDisputeView(grsDashboard): any {
    //this.logger.debug("calling get api from GRSDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/grs/dispute-details/view', grsDashboard, { observe: 'response' });
  }

  getModeWiseComplaint(grsDashboard): any {
    //this.logger.debug("calling get api from GRSDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/grs/mode-wise-complaint/view', grsDashboard, { observe: 'response' });
  }
  getAgentPerformanceReport(grsDashboard): any {
    //this.logger.debug("calling get api from GRSDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/grs/agent-performance-report/view', grsDashboard, { observe: 'response' });
  }

  getComplaintTATMatrix(grsDashboard): any {
    //this.logger.debug("calling get api from GRSDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/grs/complaint-tat-matrix/view', grsDashboard, { observe: 'response' });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboards/grs-admin-dashboard/grs-dashboard.service.ts